import { useQuery } from "@tanstack/react-query";

import { getUserInfo } from "@synthesis/shared-services/auth/user/client";
import type { UserDto } from "@synthesis/shared-services/auth/user/types";

export const useUserInformation = (userId?: string): [boolean, UserDto | null] => {
  const { data: userData, isLoading } = useQuery({
    queryKey: ["userInformation", userId],
    queryFn: async () => (await getUserInfo({ path: { userId: userId! } })).data,
    enabled: !!userId,
  });

  return [isLoading, userData ?? null];
};
